import { render, staticRenderFns } from "./BranchLedger.vue?vue&type=template&id=11246b17&"
import script from "./BranchLedger.vue?vue&type=script&lang=js&"
export * from "./BranchLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports